// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Ir1v_","svgContainer":"styles_svgContainer___yGyG"};